import type { PATHS } from "../../lib/routes.js";

/**
 * The first-visit tour, step by step (plans/help-info-and-tour.md).
 *
 * Seven at most, one idea each. The last two open their own pages, so a new
 * reader has seen Prompts and Where to publish once rather than only been told
 * they exist (Q3). Each step names the element it lights by its `data-tour`.
 */

export interface TourStep {
  /** The screen the step is on. The tour opens it when it is not showing. */
  readonly screen: keyof Pick<typeof PATHS, "overview" | "prompts" | "offPage">;
  /** The `data-tour` value of the part to light up. */
  readonly target: string;
  readonly title: string;
  readonly body: string;
}

export const TOUR_STEPS: readonly TourStep[] = [
  {
    screen: "overview",
    target: "rail",
    title: "Your brand, and its pages",
    body: "Your workspace is at the top. Under it, the brand on screen has a box of its own: press its name to switch brand, and its pages are inside. Below the box are the tools that work across all your brands.",
  },
  {
    screen: "overview",
    target: "filters",
    title: "Filters shape every number",
    body: "Pick the dates, the AI engine and the country. Everything on the page follows what you pick.",
  },
  {
    screen: "overview",
    target: "standing",
    title: "Your four numbers",
    body: "How often AI names you, your share of every mention, how early you are named, and how often first, each ranked against your rivals. Rest on a number to see how it was counted.",
  },
  {
    screen: "overview",
    target: "coverage",
    title: "The trend",
    body: "The share of answers that named each brand, day by day, with each engine beside it. Your brand is always blue.",
  },
  {
    screen: "overview",
    target: "ranking",
    title: "Who AI names",
    body: "Every brand you track, by how often the answers name it, and the most-named company you don't track yet.",
  },
  {
    screen: "prompts",
    target: "prompts",
    title: "The questions we ask",
    body: "Every question on this report, asked to each AI engine every day. Open one to read its answers word for word.",
  },
  {
    screen: "offPage",
    target: "off-page",
    title: "Where to publish next",
    body: "Sites the answers cite that you could publish on, biggest gap first. Start here when you want to act.",
  },
];
